<template>
  <div>
    <pull-to
      v-if="!isStoreBaseEnabled"
      :top-load-method="reloadProducts"
      :top-block-height="70"
      :is-throttle-scroll="false"
      :top-config="topConfig"
    >
      <template slot="top-block">
        <div class="pull-to-tab">
          <div class="spinner">
            <img :src="`${$root.cdnUrl}assets/spinner.gif`">
          </div>
        </div>
      </template>
      <template slot="bottom-block" />
      <div class="product-list">
        <ListTabs @tabChange="onTabChange" />
        <ListFilter
          @onFilter="onFilter"
          @openFilterModal="openFilterModal"
        />
        <div class="product-items">
          <NotFound
            v-if="!products.length"
          />
          <ListItem
            v-for="(product, index) in products"
            :key="index"
            :product="product"
          />
        </div>
        <Pagination
          @page="setPage"
          :pagination="pagination"
        />
      </div>
    </pull-to>
    <div v-else>
      Trendyol pazaryeri satıcısı olmadığınız için bu sayfayı görme yetkiniz bulunmamaktadır.
    </div>
    <FilterModal
      :show="showFilterModal"
      :params="params"
      @hideFilterModal="hideFilterModal"
      @onFilter="onFilter"
      :supplier-product-query-type="supplierProductQueryType"
    />
  </div>
</template>
<script>
import service from '@/services/product';
import PullTo from '@/components/PullTo';
import ListTabs from './Components/ListTabs';
import ListItem from './Components/ListItem';
import ListFilter from './Components/ListFilter';
import Pagination from '@/components/Pagination';
import NotFound from '@/components/NotFound';
import FilterModal from './Components/FilterModal';
import dayjs from 'dayjs';

export default {
  components: {
    NotFound,
    Pagination,
    ListFilter,
    ListItem,
    ListTabs,
    FilterModal,
    PullTo,
  },
  data () {
    return {
      params: {
        size: 10,
        archived: false,
        sortType: null,
      },
      products: [],
      pagination: {},
      topConfig: {
        loadedStayTime: 400,
        stayDistance: 70,
        triggerDistance: 70,
      },
      isLoading: false,
      showFilterModal: false,
    };
  },
  computed: {
    supplierProductQueryType () {
      return this.$route.meta?.queryType || null;
    },
    isStoreBaseEnabled () {
      return this.$route.query?.storeBaseEnabled;
    },
  },
  methods: {
    async setPage (page) {
      this.params.page = page;
      await this.getProducts();
    },
    isPageUpdated () {
      const vm = this;
      window.addEventListener('message', (e) => {
        try {
          const data = JSON.parse(e.data);
          data.reloadPage && vm.getProducts();
        } catch {

        }
      });
    },
    async onFilter (params) {
      this.params = {
        ...params,
        page: 0,
        size: 10,
      };
      await this.getProducts();
    },
    openFilterModal () {
      this.showFilterModal = true;
    },
    hideFilterModal () {
      this.showFilterModal = false;
    },
    async onTabChange () {
      const params = {
        barcode: null,
        stockCode: null,
        productMainId: null,
        brandIds: {},
        pimCategoryIds: {},
        sortType: {},
      };
      await this.onFilter(params);
    },
    async getProducts (options = {}) {
      if (this.isLoading) {
        return false;
      }
      this.isLoading = true;
      const params = { ...this.params };
      params.supplierProductQueryType = this.$route.meta?.queryType ? this.$route.meta.queryType : null;

      if (!params.supplierProductQueryType) {
        params.archived = false;
      }

      params.startDate = params.startDate ? dayjs(params.startDate).format('x') : null;
      params.endDate = params.endDate ? dayjs(params.endDate).format('x') : null;
      params.brandIds = params.brandIds && params.brandIds.id ? params.brandIds.id : null;
      params.pimCategoryIds = params.pimCategoryIds && params.pimCategoryIds.id ? params.pimCategoryIds.id : null;
      if (params.sortType && params.sortType.label) {
        params.sortOrder = params.sortType.value.sortOrder;
        params.sortField = params.sortType.value.sortField;
        delete params.sortType;
      } else {
        delete params.sortOrder;
        delete params.sortField;
      }

      this.products = [];
      const response = await service.getProducts({
        params,
        ...options,
      });

      this.products = response.content.map(item => {
        return {
          ...item,
          quantity: item.quantity || 0,
          listPrice: item.listPrice || 0,
          salePrice: item.salePrice || 0,
          storeId: null,
        };
      });

      this.pagination = {
        page: response.page,
        size: response.size,
        totalElements: response.totalElements,
        totalPages: response.totalPages,
      };
      this.isLoading = false;
    },
    async reloadProducts (isLoad) {
      try {
        await this.getProducts({
          hideSpinner: true,
        });
      } finally {
        isLoad('done');
      }
    },
  },
  created () {
    this.isPageUpdated();
  },
};
</script>
<style lang="scss" scoped>
  .product-list {
    position: relative;

    .product-list-header {
      margin: 0;
      padding: 20px 15px 10px;
      color: #273142;
      font-size: 20px;
      font-weight: 500;

      display: flex;
      justify-content: space-between;
      align-items: center;

      span {
        font-size: 14px;
        text-decoration: underline;
        float: right;
        color: rgb(110, 119, 135);
        max-width: 115px;
        text-align: center;
      }
    }

    .product-title {
      margin: 20px 15px;
      margin-bottom: 0;
    }

    .product-items {
      padding: 0 15px;
    }
  }
</style>
